export const siteConfig = {
  name: '89890漫画网',
  fullTitle: '洞洞杂货铺漫画-免费阅读看下拉式漫画-89890漫画网',
  description: '89890漫画网支持免费阅读洞洞杂货铺下拉式漫画，完整章节在线畅读，滑动阅读便捷省力，让追漫成为一种享受。海量热门漫画每日更新，热血、搞笑、恋爱、奇幻多种类型应有尽有。',
  keywords: '洞洞杂货铺,免费阅读,下拉式漫画,89890漫画网,完整章节,便捷省力,在线漫画,漫画阅读',
  url: 'https://89890.com',
  locale: 'zh_CN',
};